// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.show_task_status {
  background: transparent;
}
.show_task_status ion-item {
  border: 0;
  --background: transparent;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/admin/tasks/modals/copy-task/copy-task.page.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;AACJ;AAAI;EACI,SAAA;EACA,yBAAA;AAER","sourcesContent":[".show_task_status{\n    background: transparent;\n    ion-item {\n        border: 0;\n        --background: transparent;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
